import React from 'react'
import {Box, Skeleton, Divider} from '@chakra-ui/react'
import RatingSkeleton from '../ratings/skeleton'

const LoadingReviewsSkeleton = () => {
    const NUMBER_OF_SKELETONS = 3

    return (
        <Box>
            {Array.from({length: NUMBER_OF_SKELETONS}, (_, idx) => (
                <Box key={idx} padding="2rem 0">
                    <Divider colorScheme="stokkeGray" marginBottom="2rem" />
                    <RatingSkeleton variant="review" />
                    <Skeleton height="1.5rem" margin="1.5rem 0" maxWidth="13.5rem" />
                    <Skeleton height="7.9375rem" />
                </Box>
            ))}
            <Divider colorScheme="stokkeGray" />
        </Box>
    )
}

export default LoadingReviewsSkeleton
